module.exports = __webpack_public_path__ + "img/_DSC1157.547014d1.jpg";